/* eslint-disable no-console */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/style-prop-object */
/* eslint-disable max-len */
import React, { FC, ReactNode, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import {
  Autocomplete,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  TextField,
  Typography,
} from "@mui/material";
import Box, { BoxProps } from "@mui/material/Box";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Controller, FormProvider, useForm } from "react-hook-form";
import Country from "models/Country";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import Genders from "models/Enums/Genders";
import userService from "services/userService";
import { Link, useNavigate } from "react-router-dom";
import axios, { AxiosError } from "axios";
import ErrorTypes from "models/Enums/ErrorTypes";
import ValidationResultMessage from "components/shared/messageArea/ValidationResultMessage";
import ValidationResult from "models/ApiResponse/ValidationResult";
import IdentityResults from "models/ApiResponse/IdentityResults";
import classes from "../../style";
import CCV from "../ccv/Ccv";
import { SET_TOKEN, SET_USER } from "slices/global.slice";
import NotificationService from "services/notificationService";

const pays = ["Tunisie", "Italie", "Turquie"];

interface StepBoxProps extends BoxProps {
  step: number;
  visibleStep: number;
  children: ReactNode;
}

const StepBox: React.FC<StepBoxProps> = ({
  step,
  visibleStep,
  children,
  ...props
}) => {
  return (
    <Box
      {...props}
      style={{
        display: step === visibleStep ? "block" : "none",
        ...props.style,
      }}
    >
      {children}
    </Box>
  );
};

const InscriptionMail: FC<{ search: String }> = (props) => {
  const [step, setStep] = React.useState(0);
  const [validationResults, setValidationResults] = useState<
    ValidationResult[]
  >([]);
  const dispatch = useDispatch();
  const [identityResults, setIdentityResults] = useState<IdentityResults[]>([]);
  const [uploadedFile, setUploadedFile] = useState(null);
  const { countries: destinations } = useSelector(
    (state: RootState) => state.globalSlice,
  );
  const navigate = useNavigate();

  const reactHookForm = useForm({
    mode: "all",
    reValidateMode: "onChange",
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    trigger,
    setValue,
  } = reactHookForm;

  const hiddenFileInput = React.useRef(null);

  const handleClick = () => {
    if (hiddenFileInput) {
      (hiddenFileInput.current as any).click();
    }
  };

  const handleChange = (event: any) => {
    setUploadedFile(event.target.files[0]);
  };

  const onSubmit = (data: any) => {
    userService
      .addUser({
        ...data,
        pastTravels: data.pastTravels.map((c) => c.name),
        birthDay: new Date(data.birthDay).toUTCString(),
      })
      .then((response) => {
        // Redirect to /auth on success
        localStorage.setItem("token", response.token);
        dispatch(SET_TOKEN(response.token));
        dispatch(SET_USER(response.user));
        axios.defaults.headers.common.Authorization = `Bearer ${response.token}`;
        NotificationService().connect(response.token);
        if (props.search != '') {
          navigate("/liste-profils" + props.search);
        }
        else {
          navigate('/passeport');
        }
      })
      .catch((error: AxiosError) => {
        if (error.response && error.response.status === 400) {
          // Handle 400 Bad Request error
          const responseData: any = error.response.data;
          if (responseData.errorType === ErrorTypes.Validation) {
            setValidationResults(responseData.errors);
          } else if (responseData.errorType === ErrorTypes.Identity) {
            setIdentityResults(responseData.errors);
          }
          // Perform logic with the error response data
        } else {
          // Handle other errors
          // Perform general error handling logic here
        }
      });
  };

  const onSubmitError = (data: any) => {
  };

  const handleFormSubmit = () => {
    handleSubmit(onSubmit, onSubmitError)();
  };

  const validateInputByName = async (name: string | string[]) => {
    return trigger(name);
  };

  const validateDate = (value: string) => {
    const today = new Date();
    const selectedDate = new Date(value);

    if (selectedDate > today) {
      return "La date ne peut pas être dans le futur";
    }

    const ageDiff = today.getFullYear() - selectedDate.getFullYear();
    const monthDiff = today.getMonth() - selectedDate.getMonth();
    const dayDiff = today.getDate() - selectedDate.getDate();
    const age =
      monthDiff < 0 || (monthDiff === 0 && dayDiff < 0) ? ageDiff - 1 : ageDiff;

    if (age < 18) {
      return "Vous devez être âgé d'au moins 18 ans";
    }

    return true;
  };

  return (
    <FormProvider {...reactHookForm}>
      <Card sx={{ ...classes.card, height: "320px", position: "relative" }}>
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100%",
          }}
        >
          <StepBox step={step} visibleStep={0}>
            <Box>
              <Typography sx={classes.label}>Adresse e-mail</Typography>
              <FormControl fullWidth>
                <Controller
                  name="email"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: "Champ obligatoire",
                    pattern: {
                      value:
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                      message: "Adresse e-mail invalide",
                    },
                  }}
                  render={({ field: { onChange, ref, ...field } }) => (
                    <TextField
                      {...field}
                      inputRef={ref}
                      onChange={({ target: { value: fieldValue, name } }) => {
                        onChange(fieldValue);
                        if (setValue) setValue(name, fieldValue);
                      }}
                      placeholder="prénom.nom@gmail.com"
                      hiddenLabel
                      fullWidth
                      size="small"
                      error={!!errors.email}
                      helperText={errors.email?.message as string}
                    />
                  )}
                />
              </FormControl>
            </Box>
            <Box sx={{ my: 2 }}>
              <FormGroup>
                <FormControl>
                  <Controller
                    name="activeNewsLetter"
                    control={control}
                    rules={{
                      required: false,
                      // validate: (accepted) => !!accepted,
                    }}
                    defaultValue={false}
                    render={({ field }) => (
                      <FormControlLabel
                        control={
                          <Checkbox
                            {...field}
                            checked={field.value}
                            onChange={(e) => field.onChange(e.target.checked)}
                          />
                        }
                        label="J’accepte de recevoir les actualités de Caladre"
                      />
                    )}
                  />
                </FormControl>
              </FormGroup>
            </Box>
            <Box sx={{ my: 2, display: "flex", justifyContent: "flex-end" }}>
              <Button
                variant="contained"
                onClick={() => {
                  validateInputByName("email").then((valid) => {
                    if (valid) setStep(1);
                  });
                }}
              >
                Continuer
              </Button>
            </Box>
          </StepBox>
          <StepBox step={step} visibleStep={1}>
            <Box>
              <Typography sx={classes.label}>
                Mot de passe - Nombre de caractère ?
              </Typography>
              <FormControl fullWidth style={{ maxWidth: '400px' }}>
                <Controller
                  name="password"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: "Le mot de passe est requis",
                    minLength: {
                      value: 8,
                      message:
                        "Le mot de passe doit comporter au moins 8 caractères",
                    },
                    pattern: {
                      value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/,
                      message:
                        "Le mot de passe doit contenir au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial.",
                    },
                  }}
                  render={({ field: { onChange, ref, ...field } }) => (
                    <TextField
                      {...field}
                      autoComplete="new-password"
                      inputRef={ref}
                      onChange={({ target: { value: fieldValue, name } }) => {
                        onChange(fieldValue);
                        if (setValue) setValue(name, fieldValue);
                      }}
                      error={!!errors.password}
                      placeholder="8 caractères minimum"
                      hiddenLabel
                      fullWidth
                      id={field.name}
                      size="small"
                      helperText={errors.password?.message as string}
                    />
                  )}
                />
              </FormControl>
            </Box>
            <Box
              sx={{ my: 2, display: "flex", justifyContent: "space-between" }}
            >
              <Button
                startIcon={<ArrowBackIcon />}
                sx={classes.backBtn}
                variant="text"
                size="small"
                onClick={() => setStep(0)}
              >
                Retour
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  validateInputByName("password").then((valid) => {
                    if (valid) setStep(2);
                  });
                }}
              >
                Continuer
              </Button>
            </Box>
          </StepBox>
          <StepBox step={step} visibleStep={2}>
            <Box>
              <Typography sx={classes.label}>Prénom</Typography>
              <FormControl fullWidth>
                <Controller
                  name="firstName"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: "Le prénom est requis",
                    pattern: {
                      value: /^[a-zA-Zàáâäãåçèéêëìíîïðòóôöõøùúûüýÿæœ'\-\s]+$/,
                      message: "Le prénom doit contenir uniquement des lettres",
                    },
                    maxLength: {
                      value: 20,
                      message: "Le prénom ne doit pas dépasser 20 caractères",
                    },
                  }}
                  render={({ field: { onChange, ref, ...field } }) => (
                    <TextField
                      {...field}
                      inputRef={ref}
                      onChange={({ target: { value: fieldValue, name } }) => {
                        onChange(fieldValue);
                        if (setValue) setValue(name, fieldValue);
                      }}
                      placeholder="Ex : Paul"
                      hiddenLabel
                      fullWidth
                      id="firstName"
                      size="small"
                      error={!!errors.firstName}
                      helperText={errors.firstName?.message as string}
                    />
                  )}
                />
              </FormControl>
            </Box>
            <Box sx={{ mt: 2 }}>
              <Typography sx={classes.label}>Nom</Typography>
              <FormControl fullWidth>
                <Controller
                  name="lastName"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: "Le nom de famille est requis",
                    pattern: {
                      value: /^[a-zA-Zàáâäãåçèéêëìíîïðòóôöõøùúûüýÿæœ'\-\s]+$/,
                      message:
                        "Le nom de famille doit contenir uniquement des lettres",
                    },
                    maxLength: {
                      value: 20,
                      message:
                        "Le nom de famille ne doit pas dépasser 20 caractères",
                    },
                  }}
                  render={({ field: { onChange, ref, ...field } }) => (
                    <TextField
                      {...field}
                      inputRef={ref}
                      onChange={({ target: { value: fieldValue, name } }) => {
                        onChange(fieldValue);
                        if (setValue) setValue(name, fieldValue);
                      }}
                      placeholder="Ex : Dupont"
                      hiddenLabel
                      fullWidth
                      id="lastName"
                      size="small"
                      error={!!errors.lastName}
                      helperText={errors.lastName?.message as string}
                    />
                  )}
                />
              </FormControl>
            </Box>
            <Box
              sx={{ my: 2, display: "flex", justifyContent: "space-between" }}
            >
              <Button
                startIcon={<ArrowBackIcon />}
                sx={classes.backBtn}
                variant="text"
                size="small"
                onClick={() => setStep(1)}
              >
                Retour
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  validateInputByName(["firstName", "lastName"]).then(
                    (valid) => {
                      if (valid) setStep(3);
                    },
                  );
                }}
              >
                Continuer
              </Button>
            </Box>
          </StepBox>
          <StepBox step={step} visibleStep={3}>
            <Box>
              <Typography sx={classes.label}>Date de naissance</Typography>
              <FormControl fullWidth>
                <Controller
                  name="birthDay"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: "La date de naissance est requise",
                    validate: validateDate,
                  }}
                  render={({ field: { onChange, ref, ...field } }) => (
                    <TextField
                      {...field}
                      inputRef={ref}
                      onChange={({ target: { value: fieldValue, name } }) => {
                        onChange(fieldValue);
                        if (setValue) setValue(name, fieldValue);
                      }}
                      hiddenLabel
                      fullWidth
                      type="date"
                      id="birthDay"
                      size="small"
                      error={!!errors.birthDay}
                      helperText={errors.birthDay?.message as string}
                    />
                  )}
                />
              </FormControl>
            </Box>
            <Box
              sx={{ my: 2, display: "flex", justifyContent: "space-between" }}
            >
              <Button
                startIcon={<ArrowBackIcon />}
                sx={classes.backBtn}
                variant="text"
                size="small"
                onClick={() => setStep(2)}
              >
                Retour
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  validateInputByName("birthDay").then((valid) => {
                    if (valid) setStep(4);
                  });
                }}
              >
                Continuer
              </Button>
            </Box>
          </StepBox>
          <StepBox step={step} visibleStep={4}>
            <Box>
              <Typography sx={classes.label}>Sexe</Typography>
              <FormControl error={!!errors.gender} sx={{ display: "block" }}>
                <FormGroup>
                  <Controller
                    name="gender"
                    control={control}
                    defaultValue=""
                    rules={{
                      required: true,
                    }}
                    render={({ field }) => (
                      <>
                        <FormControlLabel
                          control={
                            <Checkbox
                              {...field}
                              onChange={(e) => {
                                const newValue = e.target.checked
                                  ? Genders.Male
                                  : "";
                                field.onChange(newValue);
                              }}
                              value={Genders.Male}
                              checked={field.value === Genders.Male}
                            />
                          }
                          label="Homme"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              {...field}
                              onChange={(e) => {
                                const newValue = e.target.checked
                                  ? Genders.Female
                                  : "";
                                field.onChange(newValue);
                              }}
                              value={Genders.Female}
                              checked={field.value === Genders.Female}
                            />
                          }
                          label="Femme"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              {...field}
                              onChange={(e) => {
                                const newValue = e.target.checked
                                  ? Genders.Other
                                  : "";
                                field.onChange(newValue);
                              }}
                              value={Genders.Other}
                              checked={field.value === Genders.Other}
                            />
                          }
                          label="Non précisé"
                        />
                      </>
                    )}
                  />
                  {errors.gender && (
                    <FormHelperText>
                      Veuillez sélectionner un genre.
                    </FormHelperText>
                  )}
                </FormGroup>
              </FormControl>
            </Box>
            <Box
              sx={{ my: 2, display: "flex", justifyContent: "space-between" }}
            >
              <Button
                startIcon={<ArrowBackIcon />}
                sx={classes.backBtn}
                variant="text"
                size="small"
                onClick={() => setStep(3)}
              >
                Retour
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  validateInputByName("gender").then((valid) => {
                    if (valid) setStep(5);
                  });
                }}
              >
                Continuer
              </Button>
            </Box>
          </StepBox>
          <StepBox step={step} visibleStep={5}>
            <Box>
              <Typography sx={classes.label}>Numéro de téléphone</Typography>
              <FormControl fullWidth>
                <Controller
                  name="phoneNumber"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: false,
                    pattern: {
                      value: /^(0|\+33)[1-9]([-. ]?[0-9]{2}){4}$/,
                      message:
                        "Le numéro de téléphone doit être au format français",
                    },
                  }}
                  render={({ field: { onChange, ref, ...field } }) => (
                    <TextField
                      {...field}
                      inputRef={ref}
                      onChange={({ target: { value: fieldValue, name } }) => {
                        onChange(fieldValue);
                        if (setValue) setValue(name, fieldValue);
                      }}
                      type="text"
                      placeholder="+33 XX XX XX XX"
                      hiddenLabel
                      fullWidth
                      size="small"
                      error={!!errors.phoneNumber}
                      helperText={errors.phoneNumber?.message as string}
                    />
                  )}
                />
              </FormControl>
            </Box>
            {!errors.phoneNumber && (
              <Box
                sx={{
                  mb: 2,
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                <Button sx={classes.skipStep} onClick={() => setStep(6)}>
                  Passer cette étape
                </Button>
              </Box>
            )}
            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Button
                startIcon={<ArrowBackIcon />}
                sx={classes.backBtn}
                variant="text"
                size="small"
                onClick={() => setStep(4)}
              >
                Retour
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  validateInputByName("phoneNumber").then((valid) => {
                    if (valid) setStep(6);
                  });
                }}
              >
                Continuer
              </Button>
            </Box>
          </StepBox>
          {/* <StepBox step={step} visibleStep={6}>
            <Box>
              <Typography sx={classes.label}>
                Vérification d’identité
              </Typography>
              <>
                <Button
                  variant="text"
                  sx={classes.btnStyle}
                  onClick={handleClick}
                >
                  <Avatar sx={{ bgcolor: CaladreTheme.palette.primary.main }}>
                    <FileUploadOutlinedIcon />
                  </Avatar>
                  Télécharger mon passeport ou CNI
                </Button>
                <input
                  type="file"
                  style={{ display: "none" }}
                  ref={hiddenFileInput}
                  onChange={handleChange}
                />
              </>
            </Box>
            <Box
              sx={{
                mb: 2,
                display: "flex",
                justifyContent: "start",
              }}
            >
              <Button sx={classes.skipStep} onClick={() => setStep(7)}>
                Passer cette étape
              </Button>
            </Box>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Button
                startIcon={<ArrowBackIcon />}
                sx={classes.backBtn}
                variant="text"
                size="small"
                onClick={() => setStep(5)}
              >
                Retour
              </Button>
              <Button variant="contained" onClick={() => setStep(7)}>
                Continuer
              </Button>
            </Box>
          </StepBox>
          <StepBox step={step} visibleStep={7}>
            <Box>
              <Typography sx={classes.label}>
                Vérification d’identité
              </Typography>
              <Box sx={{ my: 2, display: "flex", alignItems: "center" }}>
                <Avatar sx={{ bgcolor: CaladreTheme.palette.primary.main }}>
                  <CheckIcon />
                </Avatar>
                Titre validé
              </Box>
            </Box>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Button
                startIcon={<ArrowBackIcon />}
                sx={classes.backBtn}
                variant="text"
                size="small"
                onClick={() => setStep(6)}
              >
                Retour
              </Button>
              <Button variant="contained" onClick={() => setStep(8)}>
                Continuer
              </Button>
            </Box>
          </StepBox> */}
          <StepBox step={step} visibleStep={6}>
            <Box>
              <Typography sx={classes.label}>Mes voyages réalisés</Typography>
              <FormControl fullWidth>
                <Controller
                  name="pastTravels"
                  control={control}
                  defaultValue={[]}
                  rules={{
                    required: false,
                    // required: true,
                  }}
                  render={({ field }) => (
                    <Autocomplete
                      id="combo-box-demo"
                      {...field}
                      multiple
                      onChange={(_, value) => field.onChange(value)}
                      options={destinations}
                      getOptionLabel={(option: Country) => option.name}
                      sx={{
                        width: "100%",
                      }}
                      renderInput={(params: any) => (
                        <TextField
                          placeholder="Pays"
                          {...params}
                          error={!!errors.pastTravels}
                          fullWidth
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "0",
                              padding: "0",
                            },
                            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                            {
                              border: "0px solid #eee",
                            },
                          }}
                        />
                      )}
                    />
                  )}
                />
              </FormControl>
            </Box>
            <Box
              sx={{
                mb: 2,
                display: "flex",
                justifyContent: "start",
              }}
            >
              <Button sx={classes.skipStep} onClick={() => setStep(7)}>
                Passer cette étape
              </Button>
            </Box>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Button
                startIcon={<ArrowBackIcon />}
                sx={classes.backBtn}
                variant="text"
                size="small"
                onClick={() => setStep(5)}
              >
                Retour
              </Button>
              <Button variant="contained" onClick={() => setStep(7)}>
                Continuer
              </Button>
            </Box>
          </StepBox>
          <StepBox step={step} visibleStep={7} sx={{ overflowY: 'scroll' }}>
            <Box>
              <Typography variant="body1">
                En cliquant sur S’inscrire, vous acceptez nos <a href='/conditions-generales-utilisation' target='_blank'>Conditions générales</a>.<br />
                Découvrez comment nous recueillons, utilisons et partageons vos
                données en lisant notre <a href='/protection-des-donnees' target='_blank'>Politique de confidentialité</a>
                et comment nous utilisons les cookies et autres technologies
                similaires en consultant notre <a href='/politique-cookie' target='_blank'>Politique d’utilisation des cookies</a>.
                <br />
                Vous recevrez peut-être des notifications par texto de notre
                part et vous pouvez à tout moment vous désabonner.
              </Typography>
            </Box>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Button
                startIcon={<ArrowBackIcon />}
                sx={classes.backBtn}
                variant="text"
                size="small"
                onClick={() => setStep(6)}
              >
                Retour
              </Button>
              <Button
                variant="contained"
                type="submit"
                onClick={handleFormSubmit}
              >
                S&apos;inscrire
              </Button>
            </Box>
          </StepBox>
          {validationResults.map((res) => (
            <ValidationResultMessage errorMessage={res.errorMessage} />
          ))}
          {identityResults.map((res) => (
            <ValidationResultMessage errorMessage={res.description} />
          ))}
        </CardContent>
      </Card>
    </FormProvider>
  );
};

export default InscriptionMail;
